module.exports = __webpack_public_path__ + "img/community.eb423c2a.png";